"use strict";
exports.__esModule = true;
exports.ListSubheader = exports.ListItemSufix = exports.ListItemPrefix = exports.ListItemContent = exports.ListItem = exports.List = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
function List(props) {
    return react_1["default"].createElement(core_1.List, tslib_1.__assign({ component: "ul", disablePadding: true }, props));
}
exports.List = List;
function ListItem(props) {
    var _a = props.button, button = _a === void 0 ? false : _a, rest = tslib_1.__rest(props
    // Using `any` as a workaround for a ts issue: https://github.com/mui-org/material-ui/issues/14971
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    , ["button"]);
    // Using `any` as a workaround for a ts issue: https://github.com/mui-org/material-ui/issues/14971
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return react_1["default"].createElement(core_1.ListItem, tslib_1.__assign({ button: button }, rest));
}
exports.ListItem = ListItem;
function ListItemContent(props) {
    return react_1["default"].createElement(core_1.ListItemText, tslib_1.__assign({}, props));
}
exports.ListItemContent = ListItemContent;
function ListItemPrefix(props) {
    return react_1["default"].createElement(core_1.ListItemIcon, tslib_1.__assign({}, props));
}
exports.ListItemPrefix = ListItemPrefix;
function ListItemSufix(props) {
    return react_1["default"].createElement(core_1.ListItemSecondaryAction, tslib_1.__assign({}, props));
}
exports.ListItemSufix = ListItemSufix;
function ListSubheader(props) {
    return react_1["default"].createElement(core_1.ListSubheader, tslib_1.__assign({}, props));
}
exports.ListSubheader = ListSubheader;
//# sourceMappingURL=List.js.map